import React from 'react';
import { Card, Statistic, Icon } from 'antd';
import { ChartDataPoint } from '../types';
import BacklinksOverviewChart from './BacklinksOverviewChart';

type Props = {
    resourceType: string;
    title: JSX.Element;
    // value: string;
    // trend: React.JSX.Element;
    chartData: ChartDataPoint[];
    showChart: boolean;
};

function DiffValue({ chartData }: { chartData: ChartDataPoint[] }) {
    const firstValue = chartData[0]?.value || 0;
    const lastValue = chartData[chartData.length - 1]?.value || 0;
    const diff = lastValue - firstValue;
    //const diffAsString = diff.toLocaleString()
    const absDiff = Math.abs(diff);
    let diffAsString = absDiff.toLocaleString();

    if (diff > 0) {
        //return <span style={{ color: 'green', fontSize: "12px" }}>(+{diff})</span>;
        return <span style={{ color: 'green', fontSize: "12px" }}>(+{diffAsString})</span>;
    }

    if (diff < 0) {
        return <span style={{ color: 'red', fontSize: "12px" }}>(-{diffAsString})</span>;
    }

    return <span style={{ fontSize: "12px" }}>(+0)</span>
}

function Trend({ chartData }: { chartData: ChartDataPoint[] }) {
    const firstValue = chartData[0]?.value || 0;
    const lastValue = chartData[chartData.length - 1]?.value || 0;
    const diff = lastValue - firstValue;

    if (diff > 0) {
        return <Icon type="arrow-up" style={{ color: '#3f8600' }} />;
    }

    if (diff < 0) {
        return <Icon type="arrow-down" style={{ color: '#cf1322' }} />;
    }

    return <Icon type="swap" />;

    // if (overview && resourceType in overview && overview[resourceType].length) {
    //     let count = overview[resourceType].length;

    //     if (count > 1) {
    //         let first = overview[resourceType][0]['value'];
    //         let last = overview[resourceType][count - 1]['value'];

    //         if (first < last) {
    //             return {
    //                 type: 'arrow-up',
    //                 style: { color: '#3f8600' },
    //             };
    //         } else if (first > last) {
    //             return {
    //                 type: 'arrow-down',
    //                 style: { color: '#cf1322' },
    //             };
    //         }
    //     }
    // }
    // return { type: 'swap', style: undefined };
}

//export default function BacklinksOverviewBox({ title, value, trend, chartData, showChart }: Props) {
export default function BacklinksOverviewBox({ resourceType, title, chartData, showChart }: Props) {
    const latestValue = chartData[chartData.length - 1]?.value || 0;
    const latestValueFormatted = latestValue.toString().concat(resourceType === 'domain_rank' ? '/1000' : '');

    return (
        <div>
            {showChart && (
                <Card
                    title={
                        <Statistic
                            title={title}
                            value={latestValueFormatted}
                            prefix={<Trend chartData={chartData} />}
                            suffix={<DiffValue chartData={chartData} />}
                        />
                    }
                >
                    <BacklinksOverviewChart chartData={chartData} />
                </Card>
            )}

            {!showChart && (
                <Card>
                    <Statistic
                        title={title}
                        value={latestValueFormatted}
                        prefix={<Trend chartData={chartData} />}
                        suffix={<DiffValue chartData={chartData} />}
                    />
                </Card>
            )}
        </div>
    );
}
